import type { App } from '@grafikr/components';
import header from 'layout/header';

import geoPopup from 'components/geo-popup';

import hasUrlParam from 'utils/loaders/has-url-param';
import intersectionLoader from 'utils/loaders/intersection';
import onElementInteraction from 'utils/loaders/on-element-interaction';
import onEvent from 'utils/loaders/on-event';

export default (app: App) => {
  app.add({
    // Layout
    header,
    'geo-popup': geoPopup,

    // Components
    'address-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-address-form" */ 'components/address-form'),
    ],
    carousel: [
      intersectionLoader,
      () => import(/* webpackChunkName: "carousel" */ 'components/carousel'),
    ],
    'cart-drawer': [
      [onEvent, onElementInteraction, hasUrlParam],
      () => import(/* webpackChunkName: "component-cart-drawer" */ 'components/cart-drawer'),
    ],
    collapsible: [
      'click',
      () => import(/* webpackChunkName: "collapsible" */ 'components/collapsible'),
    ],
    copy: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-copy" */ 'components/copy'),
    ],
    'images-with-text-scrolling': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "images-with-text-scrolling" */ 'components/images-with-text-scrolling'
        ),
    ],
    'lazy-content': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-lazy-content" */ 'components/lazy-content'),
    ],
    megamenu: [
      intersectionLoader,
      () => import(/* webpackChunkName: "megamenu" */ 'components/megamenu'),
    ],
    countdown: [
      intersectionLoader,
      () => import(/* webpackChunkName: "countdown" */ 'components/countdown'),
    ],
    'sticky-scroll': [
      intersectionLoader,
      () => import(/* webpackChunkName: "countdown" */ 'components/sticky-scroll'),
    ],
    'live-search': [
      onElementInteraction,
      () => import(/* webpackChunkName: "live-search" */ 'components/live-search'),
    ],
    'mobile-nav': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-mobile-nav" */ 'components/mobile-nav'),
    ],
    'navigation-slider': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "component-navigation-slider" */ 'components/navigation-slider'
        ),
    ],
    newsletter: [
      onElementInteraction,
      () => import(/* webpackChunkName: "newsletter" */ 'components/newsletter'),
    ],
    pagination: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-pagination" */ 'components/pagination'),
    ],
    'product-item': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-product-item" */ 'components/product-item'),
    ],
    'thumbnail-carousel': [
      intersectionLoader,
      () => import(/* webpackChunkName: "thumbnail-carousel" */ 'components/thumbnail-carousel'),
    ],
    'certainly-chat': [
      onElementInteraction,
      () => import(/* webpackChunkName: "certainly-chat" */ 'components/certainly-chat'),
    ],
    'table-wrapper': [
      intersectionLoader,
      () => import(/* webpackChunkName: "table-wrapper" */ 'components/table-wrapper'),
    ],
    'video-fullscreen': [
      intersectionLoader,
      () => import(/* webpackChunkName: "video-fullscreen" */ 'components/video-fullscreen'),
    ],
    video: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-video" */ 'components/video'),
    ],
    'password-overlay': [
      intersectionLoader,
      () => import(/* webpackChunkName: "password-overlay" */ 'components/password-overlay'),
    ],
    'password-page': [
      intersectionLoader,
      () => import(/* webpackChunkName: "password-page" */ 'components/password-page'),
    ],

    // Pages
    collection: [
      intersectionLoader,
      () => import(/* webpackChunkName: "collection-main" */ 'pages/collection/main'),
    ],

    product: [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-main" */ 'pages/product/main'),
    ],
    'product-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-form" */ 'pages/product/form'),
    ],
    'product-recommendations': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "product-recommendations" */ 'pages/product/recommendations'),
    ],
    'sticky-cta': [
      intersectionLoader,
      () => import(/* webpackChunkName: "sticky-cta" */ 'pages/product/sticky-cta'),
    ],
    sizeguide: [
      onElementInteraction,
      () => import(/* webpackChunkName: "sizeguide" */ 'pages/product/sizeguide'),
    ],
    'store-availability': [
      onElementInteraction,
      () => import(/* webpackChunkName: "store-availability" */ 'pages/product/store-availability'),
    ],
    'secondhand-drawer': [
      onElementInteraction,
      () => import(/* webpackChunkName: "secondhand-drawer" */ 'pages/product/secondhand-drawer'),
    ],
    'product-images': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-images" */ 'pages/product/images'),
    ],
  });
};
